export type ExternalPartner = {
    slug: string
    url: string | null
    name: string
}

type PartnersResponse = {
    data: ExternalPartner[]
}

export const usePartners = () => {
    const client = useSanctumClient()
    return useAsyncData<PartnersResponse>(
        "external-partners",
        () => client<PartnersResponse>("/api/external-partners"),
        { server: false }
    )
}
